export default {
    //登录
    Chinese:"中文",
    English:"English",
    WMS_system:"WMS系统",
    UserAccount:"用户账号",
    password:"密码",
    RememberPassword:"记住密码",
    ForgotPassword:"忘记密码",
    RegisterAccount:"注册账号",
    login:"登录",
    Please_enter_a_user_account:"未输入用户账号",
    Please_enter_the_user_password:"未输入密码",
    SignIn:"登录中",
    LoginSuccessful:"登录成功",
  }
  